module.exports = __webpack_public_path__ + "static/media/guardian.652a1ad7.svg";